"use client";
import React from "react";

interface ContactSubmitInterface {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading: boolean;
}

export const ContactSubmit: React.FC<ContactSubmitInterface> = ({
  onClick,
  isLoading,
}) => {
  return (
    <button
      type="submit"
      className="w-full rounded-lg bg-main-700 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-main-800 focus:outline-none focus:ring-4 focus:ring-main-300 dark:bg-main-600 dark:hover:bg-main-700 dark:focus:ring-main-800 sm:w-auto"
      onClick={onClick}
    >
      {isLoading ? "Loading..." : "Submit"}
    </button>
  );
};
